import React from "react";
import { useNavigate } from "react-router-dom";
import { SpheraButtonEx } from "@sphera-cloud/component-ui-reactjs";
import { process } from "@progress/kendo-data-query";
import { LoadingPanel } from "../components/LoadingPanel";
import { CustomColumnLocalizationModal } from '../components/Modals/CustomColumnLocalizationModal';
import { CustomColumnWidthsModal } from '../components/Modals/CustomColumnWidthsModal';
import { Layout } from "../components/MasterPage/Layout";
import useFetchWithMsal from "../services/useFetchWithMsal";
import { apiRoutes } from "../services/apiRoutes";
import dateFormats from "../Data/dateFormats.json";
import { SettingsData } from '../Data/SettingsData';
import { CorporateSettings } from '../components/CorporateSettings';

export function Settings(props) {
    let navigate = useNavigate();
    const { execute, result } = useFetchWithMsal({
        scopes: props.loginConfig.protectedResources.apiDocumentList.scopes.read,
    });

    const { SaveSettings } = SettingsData({ localizations: props.localizations, navigate, execute, customer: props.customer, setcustomer: props.setcustomer, languageValue: props.languageValue });

    const [materialColumns, setmaterialColumns] = React.useState(props.customer.columns == null ? [] : props.customer.columns.originalColumns.filter(x =>  x.gridId === 1));
    const [documentColumns, setdocumentColumns] = React.useState(props.customer.columns == null ? [] : props.customer.columns.originalColumns.filter(x => x.gridId === 2));

    const dateNow = new Date();
    const formatDate = (date, dateFormatId) => {
        switch (dateFormatId) {
            case dateFormats[0].value:
                return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
            case dateFormats[1].value:
                return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
            case dateFormats[2].value:
                return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
            default:
                return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
        }
    };

    const [newId, setnewId] = React.useState(-1);
    const [DateFormatId, setDateFormatId] = React.useState(0);
    const [TimezoneId, setTimezoneId] = React.useState(0);
    const [CustomerName, setCustomerName] = React.useState("");
    const [displayDate, setdisplayDate] = React.useState("");
    const [pending, setPending] = React.useState(false);
    const [success, setsuccess] = React.useState(false);
    const [error, seterror] = React.useState(false);
    const [errorMessage, seterrorMessage] = React.useState("");
    const [publicSettingsOpen, setpublicSettingsOpen] = React.useState(true);
    const [languages, setlanguages] = React.useState([]);
    const [selectedColumn, setselectedColumn] = React.useState([]);

    const [showDetails, setshowDetails] = React.useState(false);
    const [showMaterial, setshowMaterial] = React.useState(false);

    const [defaultIngredientType, setdefaultIngredientType] = React.useState(0);
    const [defaultSensitivity, setdefaultSensitivity] = React.useState(1);
    const [preserveExisting, setpreserveExisting] = React.useState(true);
    const [appendDdiToMatSrcId, setappendDdiToMatSrcId] = React.useState(true);

    // Configurable Material Header secondary/tertiary fields (null = "None"). Primary is always materialName.
    const [secondaryHeaderColumnId, setSecondaryHeaderColumnId] = React.useState(null);
    const [tertiaryHeaderColumnId, setTertiaryHeaderColumnId] = React.useState(null);

    const [iaTextValue1Id, setIaTextValue1Id] = React.useState("");
    const [iaTextValue2Id, setIaTextValue2Id] = React.useState("");
    const [iaTextValue3Id, setIaTextValue3Id] = React.useState("");
    const [iaGeneratorPattern, setIaGeneratorPattern] = React.useState("");
    const [showCustomColumnModal, setshowCustomColumnModal] = React.useState(false);

    const [disableSave, setdisableSave] = React.useState(false);

    const [showWidthModal, setshowWidthModal] = React.useState(false);
    const [PhraseSections, setPhraseSections] = React.useState(props.customer.PhraseSections ? JSON.parse(JSON.stringify(props.customer.PhraseSections)) : []);

    const [showIaServiceAcctBtn, setshowIaServiceAcctBtn] = React.useState(false);

    const handleFormatChange = (newDateFormat) => {
        setDateFormatId(newDateFormat.value.value);
        setdisplayDate(formatDate(dateNow, newDateFormat.value.value));
    };

    const [localizationsDataState, setlocalizationsDataState] = React.useState({ skip: 0, take: 25 });
    const [localizationsDataResult, setlocalizationsDataResult] = React.useState(
        process([], localizationsDataState)
    );
    const localizationsDataStateChange = (event) => {
        setlocalizationsDataResult(process(selectedColumn.customerColumns[0].columnLocalizations, event.dataState));
        setlocalizationsDataState(event.dataState);
    };

    const toggleWidthsModal = (isMaterial) => {
        setshowWidthModal(!showWidthModal);

        if (showWidthModal) {
            setshowDetails(false);
            setshowMaterial(false);
        }
        else {
            if (!isMaterial) {
                setshowDetails(true);
                setshowMaterial(false);
            }
            else {
                setshowMaterial(true);
                setshowDetails(false);
            }
        }
    }

    const toggleCustomColumn = (columnId, gridId) => {
        setshowCustomColumnModal(!showCustomColumnModal);
        if (gridId == null)
            return;
        let column = {};
        let columns = materialColumns;
        if (gridId === 2)
            columns = documentColumns;
        for (var i = 0; i < columns.length; i++) {
            if (columns[i].columnId === columnId)
                column = columns[i];
        }
        if (column.customerColumns == null)
            column.customerColumns = [];
        if (column.customerColumns.length === 0)
            column.customerColumns.push({ ColumnId: columnId, columnLocalizations: [], customerColumnId: 0 });
        setselectedColumn(column);

        setlocalizationsDataState({ skip: 0, take: 25 });
        setlocalizationsDataResult(process(column.customerColumns[0].columnLocalizations, { skip: 0, take: 25 }));
    };

    const publicSettingsOpenChange = () => setpublicSettingsOpen(!publicSettingsOpen);
    const changedefaultIngredientType = (e) => setdefaultIngredientType(e.value);
    const changedefaultSensitivity = (e) => setdefaultSensitivity(e.value);
    const changepreserveExisting = (e) => setpreserveExisting(e.value);
    const changeappendDdiToMatSrcId = (e) => setappendDdiToMatSrcId(e.value);
    const changeiaGeneratorPattern = (e) => setIaGeneratorPattern(e.value);

    const handleSubmission = async () => {
        setPending(true);
        setdisableSave(true);
        await SaveSettings(materialColumns, documentColumns, PhraseSections, TimezoneId, DateFormatId, defaultIngredientType, defaultSensitivity, preserveExisting, iaTextValue1Id, iaTextValue2Id, iaTextValue3Id, iaGeneratorPattern, CustomerName, appendDdiToMatSrcId, secondaryHeaderColumnId, tertiaryHeaderColumnId);
        setPending(false);
        setdisableSave(false);
        setsuccess(true);
        setTimeout(function () {
            setsuccess(false);
        }, 5000);
    };

    React.useEffect(() => {
        let cust = {};
        try {
            if (props.customer.CustomerId != null)
                cust = JSON.parse(JSON.stringify(props.customer));
        } catch { }

        setTimezoneId(cust.TimezoneId);
        setCustomerName(cust.CustomerName);
        setDateFormatId(cust.DateFormatId);
        setdefaultIngredientType(cust.IadefaultFormulaType);
        setdefaultSensitivity(cust.DefaultSensitivity);
        setpreserveExisting(cust.PreserveExistingSensitivities === 1);
        setappendDdiToMatSrcId(cust.AppendDdiToMatSrcId === 1);
        setIaTextValue1Id(cust.IatextValue1Id);
        setIaTextValue2Id(cust.IatextValue2Id);
        setIaTextValue3Id(cust.IatextValue3Id);
        setIaGeneratorPattern(cust.IaidGeneratorPattern);
        setSecondaryHeaderColumnId(cust.SecondaryHeaderColumnId ?? null);
        setTertiaryHeaderColumnId(cust.TertiaryHeaderColumnId ?? null);
        setdisplayDate(formatDate(new Date(), cust.DateFormatId));
    }, [props.customer]);

    const getData = () => {
        execute("GET",
            `${apiRoutes.column.GetColumns}`).then(async (response) => {
                if (response != null) {
                    let matColumns = [];
                    let docColumns = [];
                    for (var i = 0; i < response.length; i++) {
                        let title = response[i].columnPropertyValues.find(x => x.columnPropertyId === 1).columnPropertyValue1;
                        response[i].title = title;
                        let alwaysShow = response[i].columnPropertyValues.find(x => x.columnPropertyId === 4);
                        response[i].alwaysShow = alwaysShow != null && alwaysShow.columnPropertyValue1 === "true";

                        if (response[i].customerColumns.length > 0) {
                            response[i].order = response[i].customerColumns[0].columnOrder;
                            response[i].width = response[i].customerColumns[0].width;
                        }

                        if (!response[i].width)
                            response[i].width = 200;
                        if (response[i].gridId === 1)
                            matColumns.push(response[i]);
                        else
                            docColumns.push(response[i]);
                    }
                    setmaterialColumns(matColumns.sort((a, b) => a.order - b.order));
                    setdocumentColumns(docColumns.sort((a, b) => a.order - b.order));
                }
            });
        if (languages.length === 0) {
            fetch(apiRoutes.documents.language.options, { method: "GET" }).then(async (response) => {
                setlanguages(await response.json());
            });
        }
    }

    const [gotData, setgotData] = React.useState(false);
    React.useEffect(() => {
        if (gotData || result == null)
            return;
        setgotData(true);
    }, [execute]);

    React.useEffect(() => {
        if (props.currentTenent.CustomerId == null)
            return;
        if (!props.currentTenent.IsEditConfigUser)
            navigate("/NoPermissions");
        if (props.currentTenent.IsIAUserAdmin)
            setshowIaServiceAcctBtn(true);
        if (gotData && execute != null)
            getData();
    }, [gotData, execute, props.currentTenent.CustomerId]);

    return (
        <Layout versionNumber={props.versionNumber} currentTenent={props.currentTenent} success={success} setSuccess={setsuccess}
            error={error} setError={seterror} errorMessage={errorMessage} localizations={props.localizations} changeLanguage={props.changeLanguage} languageValue={props.languageValue}>
            <br />

            {pending && (
                <LoadingPanel localizations={props.localizations} />
            )}
            <CorporateSettings languageValue={props.languageValue} localizations={props.localizations} publicSettingsOpenChange={publicSettingsOpenChange} changedefaultIngredientType={changedefaultIngredientType} setIaTextValue1Id={setIaTextValue1Id} setIaTextValue2Id={setIaTextValue2Id} setIaTextValue3Id={setIaTextValue3Id} changeiaGeneratorPattern={changeiaGeneratorPattern} toggleWidthsModal={toggleWidthsModal} materialColumns={materialColumns} execute={execute}
                changepreserveExisting={changepreserveExisting} changedefaultSensitivity={changedefaultSensitivity} setmaterialColumns={setmaterialColumns} documentColumns={documentColumns} setdocumentColumns={setdocumentColumns} setIaGeneratorPattern={setIaGeneratorPattern} iaGeneratorPattern={iaGeneratorPattern}
                CustomerName={CustomerName} setCustomerName={setCustomerName} TimezoneId={TimezoneId} setTimezoneId={setTimezoneId} PhraseSections={PhraseSections} setPhraseSections={setPhraseSections} newId={newId} setnewId={setnewId} showIaServiceAcctBtn={showIaServiceAcctBtn}
                defaultIngredientType={defaultIngredientType} iaTextValue1Id={iaTextValue1Id} iaTextValue2Id={iaTextValue2Id} iaTextValue3Id={iaTextValue3Id} preserveExisting={preserveExisting} defaultSensitivity={defaultSensitivity} toggleCustomColumn={toggleCustomColumn} DateFormatId={DateFormatId} handleFormatChange={handleFormatChange} displayDate={displayDate}
                appendDdiToMatSrcId={appendDdiToMatSrcId} changeappendDdiToMatSrcId={changeappendDdiToMatSrcId}
                secondaryHeaderColumnId={secondaryHeaderColumnId} tertiaryHeaderColumnId={tertiaryHeaderColumnId} setSecondaryHeaderColumnId={setSecondaryHeaderColumnId} setTertiaryHeaderColumnId={setTertiaryHeaderColumnId} />

            <SpheraButtonEx text={props.localizations.Save} className="configSaveBtn btn-primary mt-3 float-right mb-3 btn-primary"
                onClick={handleSubmission} disabled={disableSave} />

            <CustomColumnLocalizationModal languages={languages} showCustomColumnModal={showCustomColumnModal} dataStateChange={localizationsDataStateChange}
                localizationsDataState={localizationsDataState} newId={newId} setnewId={setnewId} dataResult={localizationsDataResult}
                toggleCustomColumn={toggleCustomColumn} localizations={props.localizations} dataState={localizationsDataState} 
                setselectedColumn={setselectedColumn} setlocalizationsDataResult={setlocalizationsDataResult} selectedColumn={selectedColumn} />
            <CustomColumnWidthsModal localizations={props.localizations} languageValue={props.languageValue} toggleWidthsModal={toggleWidthsModal} showWidthModal={showWidthModal}
                materialColumns={materialColumns} documentColumns={documentColumns} showMaterial={showMaterial} showDetails={showDetails}
                setmaterialColumns={setmaterialColumns} setdocumentColumns={setdocumentColumns} />
        </Layout>
    );
}
